export default "__VITE_ASSET__6eKC2u10__"